import { ClearOutlined } from "@ant-design/icons";
import { Button, Col, notification } from "antd";
import fileDownload from "js-file-download";
import React, { useState } from "react";
import { coreApi } from "../../api/calls";
import { useTranslation } from "react-i18next";

/**
 * @component
 * @alias CleaningExportButton
 * @property {number} idCityBranch - city_branch_id
 * @property {string} cityName - name of city
 * @property {bool} primary - sets buttons style to primary if true
 * @returns <Buttons /> that has functionality for downloading csv file
 */
const CleaningExportButton = ({ exportAll, idCityBranch, cityName, primary = false, dateFrom, dateTo }) => {
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState(false);

  return (
    <Col span={24}>
      <Button
        type={primary ? "primary" : "none"}
        loading={isLoading}
        icon={<ClearOutlined />}
        style={{ width: "100%" }}
        onClick={() => {
          setLoading(true);
          coreApi
            .get("/cleanings/export/" + idCityBranch, {
              responseType: "blob",
              params: {
                exportAll: exportAll,
                dateFrom,
                dateTo,
              },
            })
            .then((response) => {
              fileDownload(response.data, cityName !== "" ? cityName + "-cleaning-export.csv" : "invoice-export.csv");
            })
            .catch((err) => {
              notification.error({ message: t("exports.exportError") });
            })
            .finally(() => setLoading(false));
        }}
      >
        {t("exports.cleaningExport")}
      </Button>
    </Col>
  );
};

export default CleaningExportButton;
